import type { ReactElement } from 'react';

export type ConditionalWrapperProps<T extends ReactElement> = {
  condition?: boolean | null;
  wrapper: (children: T) => ReactElement;
  children: T;
};

export const ConditionalWrapper = <T extends ReactElement>({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps<T>): ReactElement => (condition ? wrapper(children) : children);
